import styles from './styles.module.scss';

import React from 'react';
import { Board } from '../Board';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    content: string;
    showModal: React.ComponentState;
    onPress: React.MouseEventHandler<HTMLDivElement>;
}

export const PortugolWebStudio = ({ content, showModal, onPress }: Props) => {
    return (
        <div data-open={showModal} className={styles.wrapper}>
            <div className={styles.wrapperInner}>
                <Board wrapperClass={styles.board}>
                    <iframe
                        width='100%'
                        height='100%'
                        src='https://portugol.dev/'
                    ></iframe>
                </Board>
            </div>
        </div>
    );
};
